import * as React from "react";
import styled from "styled-components";
import { Color, fade } from "@glossy";
import Icon, { Glyph } from "@ui-kit/icon";

export type Type = "info" | "include" | "exclude";

const Block = styled.div<{ color: string }>`
  border: 2px solid;
  border-radius: 2px;
  padding: 4px;
  border-color: ${(props) => props.color};
  background-color: ${(props) =>
    props.color === Color.Nobel ? Color.White : fade(props.color, 10)};
`;

const Title = styled.div`
  font-size: 12px;
`;

const Content = styled.div`
  padding: 6px 0;
  text-align: center;
`;

const StyledIcon = styled(Icon)`
  margin-right: 3px;
`;

function getColor(type: Type) {
  if (type === "info") {
    return Color.Nobel;
  } else if (type === "include") {
    return Color.MountainMeadow;
  } else {
    return Color.Valencia;
  }
}

interface IProps {
  title: string;
  children: React.ReactNode;
  icon: Glyph;
  type?: Type;
}

const QueriesInfoBlockModal = ({
  title,
  icon,
  type = "info",
  children,
}: IProps) => (
  <Block color={getColor(type)}>
    <Title>
      <StyledIcon glyph={icon} />
      <span>{title}</span>
    </Title>
    <Content>{children}</Content>
  </Block>
);

export default QueriesInfoBlockModal;
